module.exports = __webpack_public_path__ + "img/keyboard-arrow-down-rounded.2472def3.svg";